import { Component } from "react";
import type { ComponentType, MouseEventHandler } from "react";
import style from "./style.module.css";

/**
 * An entry of `EDITOR_SIDEBAR_TABS`. Mirrors the shape MobileBottomBar and
 * EditorShell already declare for the same `lib/constants` array.
 */
interface EditorSidebarTab {
  name: string;
  icon: ComponentType<{ size?: string; color?: string }>;
  title: string;
}

interface OptionDivProps {
  option: EditorSidebarTab;
  isActive: boolean;
  onClick: MouseEventHandler<HTMLDivElement>;
  isDisabled?: boolean;
}

interface OptionDivState {
  isHovered: boolean;
}

class OptionDiv extends Component<OptionDivProps, OptionDivState> {
  constructor(props: OptionDivProps) {
    super(props);

    this.setHoverState = this.setHoverState.bind(this);

    this.state = {
      isHovered: false
    };
  }

  setHoverState(value: boolean) {
    this.setState({
      isHovered: value
    });
  }

  render() {
    const { option, isActive, onClick, isDisabled } = this.props;
    const { isHovered } = this.state;
    const isLayersTab = () => {
      return option.name === "layers";
    };
    const usesLargeIcon = option.name === "layers" || option.name === "resize";
    const iconSize = usesLargeIcon ? "24px" : "20px";

    if (isActive) {
      return (
        <div
          className={
            isLayersTab()
              ? `${style.layerOptionDivActive} notranslate`
              : `${style.optionDivActive} notranslate`
          }
          onClick={onClick}
          onMouseLeave={() => this.setHoverState(false)}
        >
          <div className={style.optionDivActiveRoundedUpCorner} />
          <div className={style.optionDivActiveRoundedDownCorner} />
          {<option.icon size={iconSize} color="white" />}
          <span className="translate">{option.title}</span>
          {isLayersTab() && <span>& Inputs</span>}
        </div>
      );
    } else {
      return (
        <div
          className={
            isLayersTab()
              ? `${style.layerOptionDiv} notranslate`
              : `${style.optionDiv} notranslate`
          }
          onClick={onClick}
          data-disabled={isDisabled}
          onMouseOver={() => this.setHoverState(true)}
          onMouseLeave={() => this.setHoverState(false)}
          data-is-hovered={isHovered}
        >
          {<option.icon size={iconSize} color="#8F9295" />}
          <span className="translate">{option.title}</span>
          {isLayersTab() && <span>& Inputs</span>}
        </div>
      );
    }
  }
}

export default OptionDiv;
